export default __webpack_public_path__ + "static/media/walk-service.9d4b8ec2.svg";